<template>
    <transition-group
        
        
        appear
        v-on:appear="(el, done) => appear(el, done, 0.2)"
        v-on:beforeAppear="beforeAppear"
        v-on:before-enter="beforeAppear"
        v-on:enter="(el, done) => appear(el, done, 0.2)"
        v-on:leave="leaveReverse"
    >
        <div
            v-for="(slotElem, name, ix) in $slots"
            :key="`${slotElem[0].key}_${ix}`"
            v-bind:data-key="`${slotElem[0].key}_${ix}`"
            v-bind:data-index="ix"
            class="masked-slide-container-group"
            >
            <div class="content-holder" ref="content-ref">
                <slot :name="`slot-content-${ix}`"
                    class="slot-content"
                >

                </slot>
            </div>
            <div 
                ref="mask-ref"
                class="masked-slide-mask">
            </div>
        </div>

    </transition-group>
</template>

<script>
import { TimelineLite, TweenLite, Power1, Back, Sine } from 'gsap';

export default {
    props: {
        animSpeed: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            appearTimeline: new TimelineLite(),
            tween: TweenLite,
            show: true,
        }
    },

    methods: {
        beforeAppear(el, done) {
            const ix = el.dataset.index;
            const img = this.$refs['content-ref'][ix];
            const mask = this.$refs['mask-ref'][ix];

            const imgTween = this.tween.set(img, {
                opacity: 0,
                transform: 'translateX(-25px)',
            });
            const maskTween = this.tween.set(mask, {
                transformOrigin: 'top left',
                transform: 'scaleX(0.065) scaleY(0)'
            });
        },

        appear(el, done, delay) {
            const ix = el.dataset.index;
            const img = this.$refs['content-ref'][ix];
            const mask = this.$refs['mask-ref'][ix];

            this[`appearTimeline-${ix}`] = new TimelineLite({
                onComplete: () => {
                    done();
                }
            })
            if (ix <= 12 ) {
                this[`appearTimeline-${ix}`].delay(ix * delay)
            } else {
                this[`appearTimeline-${ix}`].delay(ix % 3 * delay)
            }
            

            this[`appearTimeline-${ix}`].to(mask, 0.3 * this.animSpeed, {
                ease: Sine.easeOut,
                transform: 'scaleX(0.065) scaleY(1)'
            })
            
            
            .to(mask, 0.25 * this.animSpeed, {
                ease: Sine.easeOut,
                transform: 'scaleX(1) scaleY(1)'
            }, 'showImage')
            .addLabel('showImage')
            .set(img, {
                // opacity: 0.5
            }, 'showImage')

            .to(img, 0.25 * this.animSpeed, {
                ease: Sine.easeInOut,
                transform: 'translateX(0)',
                opacity: 1
            }, 'showImage')
            .to(mask, 0.25 * this.animSpeed, {
                ease: Sine.easeInOut,
                transformOrigin: 'top right',
                transform: 'scaleX(0) scaleY(1)'
            }, 'showImage')

        },

        leave(el, done) {
            
            const ix = el.dataset.index;
            const img = this.$refs['content-ref'][ix];
            const mask = this.$refs['mask-ref'][ix];

            const leaveTimeline = new TimelineLite({
                onComplete: () => {
                    done();
                }
            });

            leaveTimeline.to(img, 0.4, {
                ease: Sine.easeInOut,
                transformOrigin: 'top left',
                transform: 'translateX(90%)'
            })
            .to(img, 0.2, {
                ease: Sine.easeIn,
                opacity: 0,
                transformOrigin: 'top right',
                transform: 'scaleX(0)'
            })

        },
        
        leaveReverse(el, done) {

            const ix = el.dataset.index;
            const img = this.$refs['content-ref'][ix];
            const mask = this.$refs['mask-ref'][ix];
            this[`appearTimeline-${ix}`].eventCallback('onReverseComplete', () => {
                done();
            })
            this[`appearTimeline-${ix}`].reverse();
        },

        templLogger(val) {
            return val;
        },

        
    },
    beforeUpdate() {
    },
    
}
</script>

<style lang="scss" >
    .masked-slide-container-group {
        // width: 100%;
        // height: 100%;
        position: relative;
        overflow: hidden;
        div.content-holder {

            img {
                
                display: block;
                margin-right: auto;
                margin-left: auto;
                height: auto;
                width: 100%;
            }
        }

        .masked-slide-mask {
            background-color: rgb(255, 106, 0);
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
        }
    }
</style>
